<template>
  <div class="article-card" @click="goDetail">
    <div class="article-card-title">{{ title }}</div>
    <img class="article-card-image" :src="url" />
  </div>
</template>

<script setup>
import { defineProps } from 'vue'

const props = defineProps({
  url: {
    type: String,
    default: ''
  },
  title: {
    type: String,
    default: ''
  },
  link: {
    type: String,
    default: ''
  }
})

function goDetail() {
  //打开一个新的窗口，跳转到链接地址
  window.open(props.link, '_blank')
}
</script>

<style lang="scss" scoped>
.article-card {
  padding: 12px;
  display: flex;
  flex-direction: column;
  background: #fff;
  cursor: pointer;
}

.article-card-image {
  align-self: flex-end;
  width: 80px;
  height: 80px;
  border-radius: 8px;
  margin-top: 8px;
}
</style>
